module.exports = __webpack_public_path__ + "static/Carrera-0c06397adfff68b5338693578caead99.png";